(() => {
  const money = (cents) =>
    new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    }).format((Number(cents) || 0) / 100);

  const requestCartAddWithXhr = (
    url,
    items,
    timeout = 20000
  ) => {
    return new Promise((resolve, reject) => {
      const request = new XMLHttpRequest();

      request.open('POST', url, true);
      request.timeout = timeout;
      request.setRequestHeader(
        'Content-Type',
        'application/json'
      );
      request.setRequestHeader(
        'Accept',
        'application/json'
      );

      request.onload = () => {
        let data = {};

        try {
          data = JSON.parse(request.responseText || '{}');
        } catch (error) {
          data = {};
        }

        if (request.status >= 200 && request.status < 300) {
          resolve(data);
          return;
        }

        reject(
          new Error(
            data.description ||
              data.message ||
              'Não foi possível adicionar o pack.'
          )
        );
      };

      request.onerror = () => {
        reject(
          new Error(
            'Falha de conexão ao adicionar o pack.'
          )
        );
      };

      request.ontimeout = () => {
        const error = new Error(
          'A adição demorou mais que o esperado. Verifique o carrinho e tente novamente.'
        );

        error.name = 'TimeoutError';
        reject(error);
      };

      request.send(JSON.stringify({ items }));
    });
  };

  const escapeHtml = (value = '') => {
    const element = document.createElement('div');

    element.textContent = value;

    return element.innerHTML;
  };

  const safeColor = (value, fallback) =>
    /^#[0-9a-f]{3,8}$/i.test(String(value || '').trim()) ? String(value).trim() : fallback;

  const state = {
    payload: null,
    products: [],
    modal: null,
    content: null,
    swap: null,
    swapList: null,
    activeSlot: null,
    trigger: null,
  };

  const clone = (value) => {
    if (typeof structuredClone === 'function') {
      return structuredClone(value);
    }

    return JSON.parse(JSON.stringify(value));
  };

  const getCurrentSubtotal = () =>
    state.products.reduce((sum, product) => {
      const unitPrice = Number(product.priceCents || 0);
      const quantity = Math.max(1, Number(product.qty) || 1);

      return sum + unitPrice * quantity;
    }, 0);

  const getCompareSubtotal = () =>
    state.products.reduce((sum, product) => {
      const currentPrice = Number(product.priceCents || 0);
      const comparePrice = Number(product.compareAtCents || currentPrice);
      const unitPrice = Math.max(currentPrice, comparePrice);
      const quantity = Math.max(1, Number(product.qty) || 1);

      return sum + unitPrice * quantity;
    }, 0);

  const getPricing = () => {
    const currentSubtotal = getCurrentSubtotal();
    const compareSubtotal = getCompareSubtotal();
    const type = state.payload?.discount?.type;
    const rawValue = Math.max(0, Number(state.payload?.discount?.value) || 0);

    let packDiscount = 0;

    if (type === 'percentage') {
      const percentage = Math.min(rawValue, 100);

      packDiscount = Math.round(currentSubtotal * (percentage / 100));
    } else if (type === 'fixed_amount') {
      packDiscount = Math.round(rawValue * 100);
    }

    packDiscount = Math.min(packDiscount, currentSubtotal);

    const total = currentSubtotal - packDiscount;
    const subtotal = Math.max(compareSubtotal, total);
    const discount = subtotal - total;

    return {
      subtotal,
      discount,
      total,
    };
  };

  const isPackAvailable = () =>
    Boolean(state.payload?.parentVariantId) &&
    state.products.every((item) => Boolean(item.variantId) && item.available !== false);

  const productRow = (product) => {
    const canSwap = Array.isArray(product.alternatives) && product.alternatives.length > 0;

    const isUnavailable = !product.variantId || product.available === false;

    const compare = Number(product.compareAtCents || product.priceCents);

    const current = Number(product.priceCents);

    return `
      <article class="digi-pack-fixo-modal__product${isUnavailable ? ' is-unavailable' : ''}">
        ${
          product.image
            ? `
              <img
                src="${escapeHtml(product.image)}"
                alt=""
                width="96"
                height="96"
              >
            `
            : `
              <span
                class="digi-pack-fixo-modal__image-placeholder"
                aria-hidden="true"
              ></span>
            `
        }

        <div class="digi-pack-fixo-modal__product-info">
          <h3>
            ${escapeHtml(product.productTitle)}
          </h3>

          ${
            product.protein
              ? `
            <p>
              ${escapeHtml(product.protein)} de proteína
            </p>
          `
              : ''
          }

          ${isUnavailable ? '<span class="digi-pack-fixo-modal__sold-out">Esgotado</span>' : ''}

          <div class="digi-pack-fixo-modal__product-price">
            ${
              compare > current
                ? `
                  <s>
                    ${money(compare)}
                  </s>
                `
                : ''
            }

            <strong>
              ${money(current)}
            </strong>

            ${
              Number(product.qty) > 1
                ? `
                  <span>
                    × ${Number(product.qty)}
                  </span>
                `
                : ''
            }
          </div>
        </div>

        ${
          canSwap
            ? `
            <button
              class="digi-pack-fixo-modal__swap-button"
              type="button"
              data-swap-slot="${Number(product.slot)}"
            >
              <span
                class="digi-pack-fixo-modal__swap-icon"
                aria-hidden="true"
              >
                <svg
                  viewBox="0 0 612.002 612.002"
                  fill="currentColor"
                  focusable="false"
                >
                  <path d="M539.655,340.297c-14.929-14.925-39.125-14.925-54.054,0c-14.925,14.927-14.925,39.127,0,54.054l8.726,8.726h-50.745c-36.955,0-63.735-35.973-100.758-96.033c37.689-61.308,64.665-98.122,102.044-98.122h49.458l-8.724,8.724c-14.925,14.927-14.925,39.127,0.002,54.052c7.463,7.463,17.241,11.193,27.025,11.193c9.781,0,19.566-3.732,27.027-11.195l52.083-52.086c13.067-13.063,20.262-30.432,20.262-48.909c0-18.475-7.192-35.842-20.257-48.912l-52.087-52.084c-14.927-14.925-39.129-14.924-54.054,0.002c-14.925,14.927-14.925,39.127,0.002,54.052l8.726,8.726h-49.461c-39.772,0-74.956,16.767-107.561,51.26c-14.434,15.27-27.468,33.099-39.785,51.797c-11.546-16.5-23.92-32.238-37.724-46.286c-37.55-38.202-78.693-56.771-125.78-56.771H38.22C17.112,132.483,0,149.595,0,170.703s17.112,38.22,38.22,38.22h95.797c48.538,0,80.845,37.948,118.974,98.08c-37.573,58.957-69.702,96.072-117.694,96.072H39.498c-21.108,0-38.222,17.111-38.222,38.22s17.112,38.22,38.222,38.22h95.797c47.087,0,88.232-18.57,125.782-56.771c13.282-13.511,25.238-28.584,36.408-44.398c11.947,18.011,24.59,35.154,38.537,49.909c32.604,34.493,67.787,51.26,107.559,51.26h50.746l-8.728,8.729c-14.925,14.925-14.925,39.125,0.002,54.051c7.463,7.463,17.241,11.193,27.025,11.193c9.78,0,19.566-3.732,27.027-11.195l52.087-52.089c26.964-26.966,26.966-70.844,0-97.818L539.655,340.297z"/>
                </svg>
              </span>
              <small>
                trocar sabor
              </small>
            </button>
            `
            : ''
        }
      </article>
    `;
  };

  const giftRow = (gift) => {
    if (!gift?.enabled || !gift.variantId) {
      return '';
    }

    const compareLabel = gift.compareLabel || money(gift.priceCents);

    const priceLabel = gift.priceLabel || money(0);

    return `
      <article
        class="digi-pack-fixo-modal__gift"
        style="
          --digi-gift-bg:
            ${safeColor(gift.background, '#f8ffe5')};

          --digi-gift-border:
            ${safeColor(gift.border, '#d4ff3f')};

          --digi-gift-title:
            ${safeColor(gift.titleColor, '#143740')};

          --digi-gift-price:
            ${safeColor(gift.priceColor, '#143740')};

          --digi-gift-badge-bg:
            ${safeColor(gift.badgeBackground, '#91a839')};

          --digi-gift-badge-text:
            ${safeColor(gift.badgeText, '#ffffff')};
        "
      >
        ${
          gift.image
            ? `
              <img
                src="${escapeHtml(gift.image)}"
                alt=""
                width="88"
                height="88"
              >
            `
            : `
              <span
                class="digi-pack-fixo-modal__image-placeholder"
                aria-hidden="true"
              ></span>
            `
        }

        <div>
          <h3>
            ${escapeHtml(gift.productTitle)}
          </h3>

          <div class="digi-pack-fixo-modal__gift-price">
            ${
              compareLabel
                ? `
                  <s>
                    ${escapeHtml(compareLabel)}
                  </s>
                `
                : ''
            }

            <strong>
              ${escapeHtml(priceLabel)}
            </strong>
          </div>
        </div>

        <span>
          ${escapeHtml(gift.badge || 'LIBERADO!')}
        </span>
      </article>
    `;
  };

  const render = () => {
    if (!state.content || !state.payload) {
      return;
    }

    const { subtotal, discount, total } = getPricing();

    const packAvailable = isPackAvailable();

    state.content.innerHTML = `
      <header class="digi-pack-fixo-modal__header">
        ${
          state.payload.badge
            ? `
              <span>
                ${escapeHtml(state.payload.badge)}
              </span>
            `
            : ''
        }

        <h2 id="digi-pack-fixo-modal-title">
          ESSE PACK INCLUI:
        </h2>
      </header>

      <div class="digi-pack-fixo-modal__products">
        ${state.products.map(productRow).join('')}
      </div>

      ${giftRow(state.payload.gift)}

      <dl class="digi-pack-fixo-modal__summary">
        <div>
          <dt>Subtotal</dt>
          <dd>${money(subtotal)}</dd>
        </div>

        <div>
          <p>Desconto</p>
          <p>
            − ${money(discount)}
          </p>
        </div>

        <div class="digi-pack-fixo-modal__total">
          <dt>Total</dt>
          <dd>${money(total)}</dd>
        </div>
      </dl>

      <button
        class="digi-pack-fixo-modal__add"
        type="button"
        data-pack-fixo-add
        ${packAvailable ? '' : 'disabled aria-disabled="true"'}
      >
        ${packAvailable ? 'ADICIONAR AO CARRINHO' : 'PACK INDISPONÍVEL'}
      </button>

      <p id="digi-pack-fixo-modal-polite-message" class="digi-pack-fixo-modal__message" aria-live="polite">
          Aplique o cupom no checkout para chegar no desconto final do pack.
      </p>
    `;
  };

  const closeSwap = () => {
    if (!state.swap) return;

    state.swap.hidden = true;
    state.activeSlot = null;
  };

  const closeModal = () => {
    closeSwap();

    if (!state.modal) return;

    state.modal.hidden = true;

    document.body.classList.remove('digi-pack-fixo-modal-open');

    state.trigger?.focus();
  };

  const openSwap = (slot) => {
    const product = state.products.find((item) => Number(item.slot) === Number(slot));

    if (!product || !state.swapList || !state.swap) {
      return;
    }

    state.activeSlot = Number(slot);

    state.swapList.innerHTML = product.alternatives
      .map(
        (alternative) => `
          <button
            class="
              digi-pack-fixo-swap__item
              ${Number(alternative.variantId) === Number(product.variantId) ? 'is-selected' : ''}
            "
            type="button"
            data-select-alternative="${Number(alternative.variantId)}"
            ${alternative.available ? '' : 'disabled'}
          >
            ${
              alternative.image
                ? `
                  <img
                    src="${escapeHtml(alternative.image)}"
                    alt=""
                    width="72"
                    height="72"
                  >
                `
                : `
                  <span
                    class="digi-pack-fixo-modal__image-placeholder"
                    aria-hidden="true"
                  ></span>
                `
            }

            <span>
              <strong>
                ${escapeHtml(alternative.productTitle)}
              </strong>

              ${
                alternative.protein
                  ? `
                <small>
                  ${escapeHtml(alternative.protein)} de proteína
                </small>
              `
                  : ''
              }

              <div class="digi-pack-fixo-swap__price">
                ${
                  alternative.available
                    ? `
                      ${
                        Number(alternative.compareAtCents) > Number(alternative.priceCents)
                          ? `
                            <s>
                              ${money(alternative.compareAtCents)}
                            </s>
                          `
                          : ''
                      }

                      <strong>
                        ${money(alternative.priceCents)}
                      </strong>
                    `
                    : `
                      <span>
                        Indisponível
                      </span>
                    `
                }
              </div>
            </span>

            <i aria-hidden="true"></i>
          </button>
        `,
      )
      .join('');

    state.swap.hidden = false;
  };

  const selectAlternative = (variantId) => {
    const index = state.products.findIndex((item) => Number(item.slot) === state.activeSlot);

    if (index < 0) return;

    const current = state.products[index];

    const replacement = current.alternatives.find((item) => Number(item.variantId) === Number(variantId));

    if (!replacement?.available) {
      return;
    }

    state.products[index] = {
      ...current,
      ...replacement,

      slot: current.slot,
      qty: current.qty,

      alternatives: current.alternatives,

      swapCollectionHandle: current.swapCollectionHandle,
    };

    closeSwap();
    render();
  };

  const createBundleId = () => {
    const suffix =
      typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
        ? crypto.randomUUID()
        : `${Date.now()}-${Math.random().toString(36).slice(2)}`;

    return ['fixed-pack', state.payload?.comboKey || 'combo', suffix].join(':');
  };

const getBundleProperties = (bundleId, role) => {
  const properties = {
    _bundleId: bundleId,

    _bundleKey: state.payload.comboKey,

    _bundleVersion: 'fixed-pack-v1',

    _bundleRole: role,

    _bundleParentVariantId:
      String(state.payload.parentVariantId),

    _bundleDiscountType:
      state.payload.discount.type,

    _bundleDiscountValue:
      String(state.payload.discount.value),
  };

  const influencerKey =
    state.payload.influencerKey?.trim();

  if (influencerKey) {
    properties._influencerKey = influencerKey;
  }

  return properties;
};

  const buildCartItems = () => {
    const bundleId = createBundleId();

    const items = state.products.map((product) => ({
      id: Number(product.variantId),

      quantity: Math.max(1, Number(product.qty) || 1),

      properties: getBundleProperties(bundleId, 'child'),
    }));

    const gift = state.payload?.gift;

    if (gift?.enabled && gift.variantId) {
      items.push({
        id: Number(gift.variantId),

        quantity: Math.max(1, Number(gift.qty) || 1),

        properties: {
          ...getBundleProperties(bundleId, 'gift'),

          _giftTitle: gift.productTitle || '',
        },
      });
    }

    return items;
  };

  const openCartDrawer = () => {
    const button = document.querySelector('[data-open-cart-sidebar]') || document.querySelector('[data-cart-toggle]');

    if (button) {
      button.click();
      return;
    }

    document.body.classList.add('open-cart-sidebar');
  };

  const requestAdd = async () => {
    const button = state.content?.querySelector('[data-pack-fixo-add]');

    const message = state.content?.querySelector('[data-pack-fixo-message]');

    const invalid = !isPackAvailable();

    if (invalid) {
      if (message) {
        message.textContent = 'Este combo possui um item indisponível ou ainda não foi configurado por completo.';
      }

      return;
    }

    const discountType = state.payload?.discount?.type;

    if (discountType !== 'percentage' && discountType !== 'fixed_amount') {
      if (message) {
        message.textContent = 'Configure corretamente o tipo de desconto deste combo.';
      }

      return;
    }

    const items = buildCartItems();

    if (!items.length) return;

    if (button) {
      button.disabled = true;
      button.classList.add('is-loading');
      button.textContent = 'ADICIONANDO...';
    }

    if (message) {
      message.textContent = '';
    }

    try {
      let result;

      if (window.location.pathname.startsWith('/collections/')) {
        result = await requestCartAddWithXhr(
          `${window.Shopify?.routes?.root || '/'}cart/add.js`,
          items
        );
      } else {
        const response = await fetch(
          `${window.Shopify?.routes?.root || '/'}cart/add.js`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify({ items }),
          }
        );

        result = await response.json();

        if (!response.ok) {
          throw new Error(
            result?.description ||
              result?.message ||
              'Não foi possível adicionar o pack.'
          );
        }
      }

      closeModal();
      openCartDrawer();

      if (typeof Shopify !== 'undefined' && typeof Shopify.getCart === 'function') {
        Shopify.getCart((cart) => {
          if (typeof window.updateCart === 'function') {
            window.updateCart(cart);
          }

          document.dispatchEvent(
            new CustomEvent('digi:cart-updated', {
              detail: {
                cart,
                source: 'fixed-pack-v1',
              },
            }),
          );
        });
      } else {
        document.dispatchEvent(
          new CustomEvent('digi:cart-updated', {
            detail: {
              result,
              source: 'fixed-pack-v1',
            },
          }),
        );
      }
    } catch (error) {
      console.error('[Digi Pack Fixo] Erro ao adicionar pack:', error);

      if (message) {
        message.textContent = error.message || 'Não foi possível adicionar o pack. Tente novamente.';
      }
    } finally {
      if (button) {
        const packAvailable = isPackAvailable();

        button.disabled = !packAvailable;
        button.setAttribute('aria-disabled', String(!packAvailable));
        button.classList.remove('is-loading');
        button.textContent = packAvailable ? 'ADICIONAR AO CARRINHO' : 'PACK INDISPONÍVEL';
      }
    }
  };

  document.addEventListener('digi:open-fixed-pack-modal', (event) => {
    if (!event.detail) return;

    state.payload = clone(event.detail);

    state.products = clone(event.detail.products || []);

    state.modal = document.querySelector('[data-pack-fixo-modal]');

    state.content = state.modal?.querySelector('[data-pack-fixo-modal-content]');

    state.swap = document.querySelector('[data-pack-fixo-swap]');

    state.swapList = state.swap?.querySelector('[data-pack-fixo-swap-list]');

    state.trigger = document.activeElement;

    if (!state.modal || !state.content) {
      return;
    }

    render();

    state.modal.hidden = false;

    document.body.classList.add('digi-pack-fixo-modal-open');

    state.modal.querySelector('[data-pack-fixo-close]')?.focus();
  });

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-pack-fixo-close]')) {
      closeModal();
    }

    if (event.target.closest('[data-pack-fixo-swap-close]')) {
      closeSwap();
    }

    const swapButton = event.target.closest('[data-swap-slot]');

    if (swapButton) {
      openSwap(swapButton.dataset.swapSlot);
    }

    const alternative = event.target.closest('[data-select-alternative]');

    if (alternative) {
      selectAlternative(alternative.dataset.selectAlternative);
    }

    if (event.target.closest('[data-pack-fixo-add]')) {
      requestAdd();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') {
      return;
    }

    if (state.swap && !state.swap.hidden) {
      closeSwap();
    } else if (state.modal && !state.modal.hidden) {
      closeModal();
    }
  });
})();
